<div class="carousel owl-carousel carousel-autoheight">
  <div class="item">
    <div class="banner-search">
      <div class="row">
        <div class="col-lg-6">
          <h2 class="text-banner text-white">
            <span>¡El espacio de tus</span>
            <span>sueños a un solo clic!</span>
          </h2>
          <a
            href="/auth/register"
            class="btn btn-blue mt-1 pt-2 pb-1 px-4 shadow"
          >
            <h5>Registrate aquí</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="item">
    <div class="banner-search">
      <div class="row">
        <div class="col-lg-6">
          <h2 class="text-banner text-white">
            <span>¡El espacio de tus</span>
            <span>sueños a un solo clic!</span>
          </h2>
          <a
            href="/auth/register"
            class="btn btn-blue mt-1 pt-2 pb-1 px-4 shadow"
          >
            <h5>Registrate aquí</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="container pb-2">
  <h2 class="font-weight-bold text-center mb-2 d-none d-lg-block text-red">
    Todos los proyectos
  </h2>
  <h3 class="font-weight-bold text-center mb-2 d-lg-none text-red">
    Todos los proyectos
  </h3>

  <div class="row">
    <div class="col-lg-3">
      <div
        class=""
      >
        <div class="mb-2">
          <input
            [(ngModel)]="keywords"
            type="text"
            class="w-100 px-2 mt-0"
            placeholder="Buscar proyecto"
            (keyup.enter)="filtrar()"
          />
        </div>
        <div class="mb-2">
          <input
            [(ngModel)]="business"
            type="text"
            class="w-100 px-2 mt-0"
            placeholder="Buscar por constructora"
            (keyup.enter)="filtrar()"
          />
        </div>

        <div class="mb-2">
          <input
            [(ngModel)]="city"
            type="text"
            class="w-100 px-2 mt-0"
            placeholder="Buscar por ciudad/departamento"
            (keyup.enter)="filtrar()"
          />
        </div>

        <div class="mb-2">
          <div class="form-row align-items-center">
            <div class="col">
              <input
                [(ngModel)]="price_min"
                type="number"
                class="w-100 px-2 mt-0"
                placeholder="Precio mínimo"
                (keyup.enter)="filtrar()"
              />
            </div>
            <div class="col-auto">-</div>
            <div class="col">
              <input
                [(ngModel)]="price_max"
                type="number"
                class="w-100 px-2 mt-0"
                placeholder="Precio máximo"
                (keyup.enter)="filtrar()"
              />
            </div>
          </div>
        </div>

        <div class="text-right">
          <button class="btn btn-red btn-rounded ml-auto" (click)="filtrar()">
            FILTRAR
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <!-- content -->
      <div class="border-bottom border-secondary small mb-1 pb-1">
      <div class="row justify-content-between">
        <div class="col">
          <div class="text-red small font-weight-bold">
            {{ projects?.length || "0" }} resultados
          </div>
        </div>
        <div class="col">
          <div
            class="text-right text-red small cursor-pointer"
            *ngIf="activeFilter"
            (click)="getAllProjects()"
          >
            Borrar filtros <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
      </div>


      <div class="row" *ngIf="projects?.length == 0 && hayRespuesta">
        No se encontraron proyectos
      </div>
      <div class="row" *ngIf="projects?.length > 0; else loading">
        <div class="col-lg-4" *ngFor="let project of projects; let i = index">
          <div class="card mb-3">
            <a [href]="'/constructoras/' + slug + '/proyecto/' + project.slug">
              <img
                [src]="
                  project.first_image?.original ||
                  '/assets/img/constructoras/top-default.png'
                "
                class="card-img-top"
                alt=""
              />
            </a>
            <div class="card-info-company">
              <div class="row align-items-center">
                <div class="col-4 pr-0">
                  <div class="card-logo text-center">
                    <img
                      [src]="
                        project?.logo ||
                        'assets/img/constructoras/logo-default.png'
                      "
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-7 px-0">
                  <div class="card-stage text-center">
                    <div
                      class="btn-small btn-rounded bg-blue small text-white py-1 lh-1"
                    >
                      Desde ${{ project.currency }}
                      {{ project.amount | number }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body pt-1 pb-2 text-center">
              <a
                [href]="'/constructoras/' + slug + '/proyecto/' + project.slug"
              >
                <h6
                  class="text-blue font-weight-bold mb-0 text-truncate"
                  [title]="project.title || 'Proyecto en'"
                >
                  {{ project.title || "Proyecto en" }}
                </h6>
              </a>
              <h6 class="text-center text-truncate text-capitalize small mb-1 font-weight-bold" title="{{ project.zone }}, {{ project.city }}">
                {{ project.zone }}, {{ project.city }}
              </h6>

              <div
                class="font-italic text-truncate small lh-1 mb-1"
                title="{{ project.address }}"
              >
                {{ project.address }}
              </div>

              <div class="small">
                <p class="mb-0 lh-1"><b>Entrega estimada:</b>
                  {{
                    project.stimated_date
                      ? (project.stimated_date | date : "yyyy-MM-dd")
                      : "Sin fecha"
                  }}
                </p>
              </div>

              <div class="row">
                <a
                  class="btn btn-red btn-rounded w-100 font-italic mt-2"
                  [href]="
                    '/constructoras/' +
                    project.profile?.slug +
                    '/proyecto/' +
                    project.slug
                  "
                >
                  <small> VER INMUEBLES </small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="my-2 text-center" *ngIf="projects?.length > 12">
        <a
          class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
        >
          <span class="px-4"> CARGAR MÁS RESULTADOS</span>
        </a>
      </div>

      <!-- end content -->
    </div>
  </div>
</section>

<ng-template #loading>
  <div class="emptyBlock p-5 text-center" *ngIf="!hayRespuesta">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
